import * as React from 'react';
import lowerCase from 'lodash/lowerCase';
import classes from './NavigationElementDetailsMobile.module.esm.js';

var NavigationElementDetailsMobile = function (_a) {
    var _b = _a.fields, firstColumn = _b.firstColumn, link = _b.link, secondColumn = _b.secondColumn, thirdColumn = _b.thirdColumn, title = _b.title, BaseComponent = _a.BaseComponent;
    if (!BaseComponent) {
        console.warn('No BaseComponent provided');
        return null;
    }
    return (React.createElement("ul", { className: classes.root, "data-cy": "nav_".concat(lowerCase(title), "-mobileContainer") },
        link && (React.createElement("li", { className: classes.linkWrapper, "data-testid": "L2-link" },
            React.createElement(BaseComponent, { BaseComponent: BaseComponent, classes: { root: classes.link }, source: link.fields.linkScheme }, link.fields.text))), firstColumn === null || firstColumn === void 0 ? void 0 :
        firstColumn.map(function (navSubElement) { return (React.createElement(BaseComponent, { BaseComponent: BaseComponent, key: navSubElement.sys.id, source: navSubElement })); }), secondColumn === null || secondColumn === void 0 ? void 0 :
        secondColumn.map(function (navSubElement) { return (React.createElement(BaseComponent, { BaseComponent: BaseComponent, key: navSubElement.sys.id, source: navSubElement })); }), thirdColumn === null || thirdColumn === void 0 ? void 0 :
        thirdColumn.map(function (navSubElement) { return (React.createElement(BaseComponent, { BaseComponent: BaseComponent, key: navSubElement.sys.id, source: navSubElement })); })));
};

export { NavigationElementDetailsMobile as default };
//# sourceMappingURL=NavigationElementDetailsMobile.esm.js.map
